import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaixaListarComponent } from './caixa-listar.component';


@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: CaixaListarComponent}
  ])],
  exports: [RouterModule]
})
export class CaixaListarRoutingModule { }
